// src/pages/PrivacyPolicy.jsx
import React from "react";

export default function PrivacyPolicy() {
  return (
    <div className="max-w-5xl mx-auto px-4 py-10">
      <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>

      <p className="text-slate-800 leading-7">
        We respect your privacy. We collect only the information needed to provide Piano With
        Pan and process payments—such as your name, contact details, login details, and
        transaction/payment status.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">What we collect</h2>
      <ul className="list-disc ml-6 text-slate-800 leading-7">
        <li>
          <span className="font-semibold">Account info:</span> name and email (and related
          authentication details) to create and manage your account.
        </li>
        <li>
          <span className="font-semibold">Payment info:</span> payment status, plan/pass type,
          and transaction identifiers from our payment and backend providers (we do not store
          full card details).
        </li>
        <li>
          <span className="font-semibold">Usage &amp; device info (Analytics):</span> basic
          usage data such as pages visited, clicks, scrolls, approximate location (country/city),
          device/browser info, and how users navigate the site.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-2">How we use data</h2>
      <ul className="list-disc ml-6 text-slate-800 leading-7">
        <li>Provide access to lessons, levels, and progress features</li>
        <li>Process payments via a secure third-party payment gateway</li>
        <li>Enable account login, security, and customer support</li>
        <li>Send essential emails about your account and purchases</li>
        <li>Improve performance, fix bugs, and understand what features users use most</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-2">Google Analytics</h2>
      <p className="text-slate-800 leading-7">
        We use Google Analytics to understand how people use our website (for example: which
        pages are visited, how long users stay, what buttons are clicked, and how users move
        through the site). This helps us improve the product, measure traffic, and understand
        which parts of Piano With Pan are most helpful.
      </p>
      <p className="text-slate-800 leading-7 mt-3">
        Google Analytics may use cookies and similar technologies to collect this information.
        Google may process this data as a service provider. You can learn more about how Google
        uses data from sites and apps that use Google services here:{" "}
        <a
          className="text-sky-600 hover:underline"
          href="https://policies.google.com/technologies/partner-sites"
          target="_blank"
          rel="noreferrer"
        >
          https://policies.google.com/technologies/partner-sites
        </a>
        .
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">Data sharing</h2>
      <p className="text-slate-800 leading-7">
        We do not sell personal data. We share limited information with trusted service
        providers strictly to deliver and run the service, such as:
      </p>
      <ul className="list-disc ml-6 text-slate-800 leading-7 mt-2">
        <li>
          <span className="font-semibold">Payments:</span> Razorpay (to process payments
          securely)
        </li>
        <li>
          <span className="font-semibold">Authentication &amp; backend:</span> our backend and
          database providers (to manage accounts, passes, and access control)
        </li>
        <li>
          <span className="font-semibold">Analytics:</span> Google Analytics (to understand
          traffic and improve the site)
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-2">Cookies &amp; consent</h2>
      <p className="text-slate-800 leading-7">
        We use:
      </p>
      <ul className="list-disc ml-6 text-slate-800 leading-7 mt-2">
        <li>
          <span className="font-semibold">Strictly necessary cookies</span> for core
          functionality such as login/session, security, and keeping the site working properly.
          These are required for the service to operate.
        </li>
        <li>
          <span className="font-semibold">Analytics cookies</span> (Google Analytics) to help
          us understand usage and improve the product. Where required by law, we will ask for
          your consent before setting analytics cookies. If you choose not to consent, we will
          not use analytics cookies.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-2">Your choices</h2>
      <ul className="list-disc ml-6 text-slate-800 leading-7">
        <li>
          You can choose whether to allow analytics cookies through our cookie consent prompt
          (where shown).
        </li>
        <li>
          You can also block or delete cookies through your browser settings. Note: blocking
          strictly necessary cookies may affect login and core site functionality.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-2">Data retention</h2>
      <p className="text-slate-800 leading-7">
        We keep data only as long as needed for providing the service, meeting legal/financial
        requirements, preventing abuse, and resolving disputes. Analytics data is retained
        according to our analytics settings.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">Contact</h2>
      <p className="text-slate-800 leading-7">
        Email:{" "}
        <a className="text-sky-600 hover:underline" href="mailto:nishatchadha@gmail.com">
          nishatchadha@gmail.com
        </a>{" "}
        • Phone:{" "}
        <a className="text-sky-600 hover:underline" href="tel:+919833255196">
          +91 98332 55196
        </a>
      </p>

      <p className="text-slate-500 text-sm mt-8">
        Last updated: 1 March 2026
      </p>
    </div>
  );
}